import React from 'react'
import { SliderOnboarding } from '@/components/SliderOnboarding'
import { QuestionProps } from '../types'
import { createLog } from '@/utils'

const DEBUG = false
const log = createLog('WorkSatisfactionCard', DEBUG)

export const WorkSatisfactionCard = (props: QuestionProps) => {
  const { form, disabled } = props

  log('Rendering WorkSatisfactionCard', { formValues: form.values, disabled, value: form.values.satisfaction_at_work })

  function onValueChange(value: number | number[]) {
    log('onValueChange called', { value })
    if (Array.isArray(value)) value = value[0]

    form.setFieldValue('satisfaction_at_work', value)
  }

  return (
    <SliderOnboarding
      {...form.register('satisfaction_at_work')}
      onValueChange={onValueChange}
      disabled={disabled}
      label=''
    />
  )
}
